import { MarginsResponse } from "../../../../api/useGetMargins";
import { getCurrencyValue } from "../../../CallAlertsAuxWindow/auxUtils";

export const buildRequirements = (overnightBuyingPower: MarginsResponse) => {
  // Rename to match Ascend
  const {
    nonOptionsRequirementNotConcentrated,
    nonOptionsRequirement,
    optionsRequirement,
    marginConcentrationExcess: marginRequirementWithConcentration,
    marginRequirementNYSE: marginRequirementNyse,
    marginRequirement,
  } = overnightBuyingPower;
  return [
    {
      label: "Non-Options Requirement",
      value: getCurrencyValue(nonOptionsRequirementNotConcentrated),
      isNumeric: true,
    },
    {
      label: "Non-Options Requirement with Concentration",
      value: getCurrencyValue(nonOptionsRequirement),
      isNumeric: true,
    },
    {
      label: "Options Requirement",
      value: getCurrencyValue(optionsRequirement),
      isNumeric: true,
    },
    {
      label: "Total Requirement",
      value: getCurrencyValue(marginRequirement),
      isNumeric: true,
    },
    {
      label: "Total Requirement with Concentration",
      value: getCurrencyValue(marginRequirementWithConcentration),
      isNumeric: true,
    },
    {
      label: "Margin Requirement NYSE",
      value: getCurrencyValue(marginRequirementNyse),
      isNumeric: true,
    },
  ];
};
